import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";

const BadgeTvaPercentage = ({ rate = null }) => {
    if (!rate) return null;
    return (
        <SBadge vAlign="center" hAlign="center">
            <SText content={`${rate}`} />
        </SBadge>
    );
};

export default BadgeTvaPercentage;

const SText = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px; /* 120% */
`;

const SBadge = styled(Flex)`
    height: 16px;
    padding: 2px 6px;
    gap: 2px;

    border-radius: 100px;
    background: var(
        --Light-theme-Rest-Background-Default-Background-3,
        #f0f0f0
    );
`;
